import { render, staticRenderFns } from "./ConsumeTypePage.vue?vue&type=template&id=0c9fddca&scoped=true&"
import script from "./ConsumeTypePage.vue?vue&type=script&lang=js&"
export * from "./ConsumeTypePage.vue?vue&type=script&lang=js&"
import style0 from "./ConsumeTypePage.vue?vue&type=style&index=0&id=0c9fddca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9fddca",
  null
  
)

export default component.exports